<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-coins"></i> Kas Kecil
                </div>
                <div class="card-tools mr-0">
                    <button
                        :disabled="isLoading"
                        class="btn btn-primary"
                        @click="exportExcel()"
                    >
                        <i class="fa fa-file-excel"></i> Export Excel
                    </button>
                    <button
                        :disabled="isLoading"
                        type="button"
                        class="btn btn-primary"
                        @click="printList"
                    >
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button
                        v-if="$can('manage kategori pengeluaran')"
                        type="button"
                        class="btn btn-primary mr-1"
                        @click="manageKategori"
                    >
                        <i class="fas fa-tags"></i> Kategori
                    </button>
                    <button
                        v-if="$can('create kas kecil')"
                        type="button"
                        class="btn btn-primary"
                        @click="addPengeluaran"
                    >
                        <i class="fas fa-plus-square"></i> Pengeluaran
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-2">
                    <search-bar
                        @search-set="searchSet"
                        @search-reset="searchReset"
                    ></search-bar>
                </div>
                <div
                    class="alert alert-primary mb-3 h4"
                    role="alert"
                    v-if="gudang"
                >
                    SALDO :
                    <strong class="text-nowrap"
                        >Rp.
                        {{ formatNumberStrict(gudang.saldo_kas_kecil) }}</strong
                    >
                </div>
                <div class="table-responsive">
                    <vuetable
                        ref="vuetable"
                        api-url="/api/kas-kecils"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="photo" slot-scope="props">
                            <span v-if="props.rowData.photo">
                                <a
                                    :href="props.rowData.photo"
                                    target="_blank"
                                    class="btn btn-link px-1 text-success"
                                    ><i class="fas fa-external-link-alt"></i
                                ></a>
                            </span>
                            <span v-else>-</span>
                        </template>
                        <template slot="kategori" slot-scope="props">
                            <span v-if="props.rowData.kategori_pengeluaran">
                                {{ props.rowData.kategori_pengeluaran.name }}
                            </span>
                            <span v-else>-</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button
                                v-if="
                                    ($can('create kas kecil') &&
                                        isSameDay(props.rowData.created_at)) ||
                                    isSuperAdmin
                                "
                                type="button"
                                title="Edit"
                                @click="edit(props.rowData)"
                                class="btn btn-link px-1"
                            >
                                <i class="fas fa-edit"></i>
                            </button>
                            <button
                                v-if="isSuperAdmin"
                                type="button"
                                title="Delete"
                                @click="deleteItem(props.rowData)"
                                class="btn btn-link px-1 text-danger"
                            >
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination
                        ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page
                        :perPage="perPage"
                        @update="onChangePerPage"
                    ></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal
            v-model="editModal"
            size="md"
            :hide-header="true"
            :hide-footer="true"
        >
            <edit-form
                :value="currentKasKecil"
                :gudang="userGudang"
                @saved="saved"
                @cancel="editModal = false"
            ></edit-form>
        </b-modal>

        <b-modal
            v-model="kategoriModal"
            size="lg"
            :hide-header="true"
            :hide-footer="true"
        >
            <kategori-pengeluaran-manager
                @cancel="kategoriModal = false"
            ></kategori-pengeluaran-manager>
        </b-modal>
    </section>
</template>

<script>
import VuetableMixin from "../../mixin/vuetable2";
import SearchBar from "./SearchBar";
import ExportMixin from "../../mixin/export";
import EditForm from "./Form";
import KategoriPengeluaranManager from "./KategoriPengeluaranManager";

export default {
    name: "kas-kecil",

    components: {
        SearchBar,
        EditForm,
        KategoriPengeluaranManager,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentKasKecil: null,
            searchText: "",
            searchDate: "",
            searchGudangId: "",
            searchKategoriId: "",
            editModal: false,
            kategoriModal: false,
            gudang: null,
            exportUrl: "/export/kas-kecils",
        };
    },

    created() {},

    mounted() {
        if (this.userGudang) {
            this.loadGudang(this.userGudang.id);
        }
    },

    computed: {
        customFields() {
            return [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: "updated_at",
                    title: "Tanggal Pengeluaran",
                    sortField: "updated_at",
                    callback: "formatDate",
                },
                {
                    name: "gudang.name",
                    title: "Gudang",
                    sortField: "gudang_name",
                },
                {
                    name: "__slot:kategori",
                    title: "Kategori",
                    sortField: "kategoriPengeluaran",
                },
                {
                    name: "nominal",
                    title: "Nominal",
                    sortField: "nominal",
                    callback: "formatNumber",
                },
                {
                    name: "__slot:photo",
                    title: "Foto",
                },
                {
                    name: "notes",
                    title: "Keterangan",
                    sortField: "notes",
                },
                {
                    name: "metode_pembayaran",
                    title: "Metode",
                    sortField: "metode_pembayaran",
                },
                {
                    name: "__slot:action",
                    title: "Aksi",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ];
        },

        sortOrder() {
            return [{ field: "updated_at", direction: "desc" }];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                gudang_id: this.searchGudangId,
                kategori_pengeluaran_id: this.searchKategoriId,
                is_pengeluaran: true,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGudangId = search.searchGudangId;
            this.searchKategoriId = search.searchKategoriId;
            this.refresh();
            if (this.searchGudangId || this.userGudang) {
                this.loadGudang(this.searchGudangId || this.userGudang.id);
            }
        },

        searchReset() {
            this.searchText = "";
            this.searchDate = "";
            this.searchGudangId = "";
            this.searchKategoriId = "";
            this.refresh();
            this.gudang = null;
            if (this.userGudang) {
                this.loadGudang(this.userGudang.id);
            }
        },

        addPengeluaran() {
            this.currentKasKecil = null;
            this.editModal = true;
        },

        manageKategori() {
            this.kategoriModal = true;
        },

        edit(rowData) {
            this.currentKasKecil = Object.assign({}, rowData);
            this.editModal = true;
        },

        saved() {
            this.editModal = false;
            this.currentKasKecil = null;
            this.refresh();
            if (this.searchGudangId || this.userGudang) {
                this.loadGudang(this.searchGudangId || this.userGudang.id);
            }
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement("iframe");
            newIframe.width = "0";
            newIframe.height = "0";
            let params = this.convertExportParams("print");
            newIframe.src = `/kas-kecils/list/print` + "?" + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            };
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: "Apakah anda yakin?",
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Ya, hapus!",
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: "delete",
                        url: "/api/kas-kecils/" + rowData.id,
                    })
                        .then(function (response) {
                            Toast.fire({
                                icon: "success",
                                title: response.data.message,
                            });
                            self.isLoading = false;
                            self.$Progress.finish();
                            self.refresh();
                            if (self.searchGudangId || self.userGudang) {
                                self.loadGudang(
                                    self.searchGudangId || self.userGudang.id
                                );
                            }
                        })
                        .catch(function (error) {
                            self.responseFailed(error);
                        });
                }
            });
        },

        loadGudang(gudangId) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: "get",
                url: "api/gudangs/" + gudangId,
            })
                .then(function (response) {
                    self.$Progress.finish();
                    self.isLoading = false;
                    self.gudang = Object.assign({}, response.data.data);
                })
                .catch(function (error) {
                    self.requestFailed(error);
                });
        },
    },
};
</script>
